<template>
  <f7-sheet class="high darker" :backdrop="true" :opened="show" @sheet:closed="$emit('closed')">
    <f7-toolbar>
      <div class="left"></div>
      <div class="right">
        <f7-link sheet-close>
          Sluiten
        </f7-link>
      </div>
    </f7-toolbar>
    <f7-block class="p-0">

      <div class="px-4 my-3 p-0 m-0">
        <h6>
          Uitleg van de reservering slots
        </h6>
      </div>

      <div>
        <f7-list id="calendar-events" class="no-margin no-safe-area-left calendar-help-events list-strong list-dividers">
          <f7-list-item v-bind:class="{'full': false}" class="pl-0">
            <div class="event-color" :style="{'background-color': '#61fa40'}" slot="root-start"></div>
            <div class="ml-4">
              (1/7) Er is één eiland bezet in de gym, en er zijn nog eilanden om te reserveren. Tik er op om een eiland te kiezen.
            </div>
          </f7-list-item>
          <f7-list-item v-bind:class="{'full': false}" class="pl-0">
            <div class="event-color" :style="{'background-color': '#c9c9c9'}" slot="root-start"></div>
            <div class="ml-4">

              (2/7) Er zijn 2 anderen in de gym aan het sporten, maar er zijn geen eilanden beschikbaar voor de tijdsduur dat jij graag wil sporten. Dit komt omdat ze in één van de volgende tijdslots <em>wel</em> bezet zijn. Pas de gewenste tijdsduur aan via het tandwiel (<f7-icon f7="gear_alt"></f7-icon>), of kies een andere tijd.
            </div>
          </f7-list-item>
          <f7-list-item v-bind:class="{'full': false}" class="pl-0">
            <div class="event-color" :style="{'background-color': '#c9c9c9'}" slot="root-start"></div>
            <div class="ml-4">
              (7/7) Alle eilanden zijn bezet. Kies een andere tijd om te sporten.
            </div>
          </f7-list-item>
        </f7-list>
      </div>

    </f7-block>
  </f7-sheet>
</template>

<script>

export default {
  components: {},

  props: [
    'show',
  ],

  mixins: [],

  data: function () {
    return {
      //
    };
  },

  computed: {
    //
  },

  created() {
    //
  },

  mounted() {
    //
  },

  methods: {
    //
  },

  watch: {
    //
  }
};
</script>
<style lang="scss">
  .calendar-help-events {
    .item-content {
      padding-left: 0px!important;
    }
  }
</style>
